import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SitesLocationMap from "./sitesLocationMap";
import { fetchSitesLocationMap } from "services/redux/sitesLocationMap/action"

const mapStateToProps = (state) => ({
  sitesLocMapList: state.sitesLocMapReducer.sitesLocMapList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({fetchSitesLocationMap}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SitesLocationMap);
